var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatNewPartnerco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12c0 1.5.348 2.91.96 4.18L2 22l5.82-.96C9.09 21.652 10.5 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z",
    id: "chat-bubble",
    stroke: "#3a9d8f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot-1",
    cx: 9,
    cy: 12,
    r: 1,
    fill: "#3a9d8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot-2",
    cx: 12,
    cy: 12,
    r: 1,
    fill: "#3a9d8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot-3",
    cx: 15,
    cy: 12,
    r: 1,
    fill: "#3a9d8f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNewPartnerco);
export default __webpack_public_path__ + "static/media/chat_new_partnerco.37d815cb1caba6ef3a0d223dd1b11f58.svg";
export { ForwardRef as ReactComponent };